import { useLinkToolbarButton, useLinkToolbarButtonState } from '@platejs/link/react';
import { Link } from 'lucide-react';
import type { ComponentProps } from 'react';
import { ToolbarButton } from './toolbar';

export const LinkToolbarButton = (props: ComponentProps<typeof ToolbarButton>) => {
  const state = useLinkToolbarButtonState();
  const { props: buttonProps } = useLinkToolbarButton(state);

  return (
    <ToolbarButton {...props} {...buttonProps} data-plate-focus tooltip="Link">
      <Link />
    </ToolbarButton>
  );
};
